import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/**  @jsx jsx */
import { forwardRef } from 'react';
import { jsx } from '@emotion/core';
export default /*#__PURE__*/forwardRef(function (_ref, ref) {
  var createAnalyticsEvent = _ref.createAnalyticsEvent,
      attributesFn = _ref.attributesFn,
      testId = _ref.testId,
      props = _objectWithoutProperties(_ref, ["createAnalyticsEvent", "attributesFn", "testId"]);

  return jsx("input", _extends({
    type: "checkbox"
  }, attributesFn({
    disabled: props.disabled,
    checked: props.checked,
    required: props.required
  }), props, {
    ref: ref,
    css: {
      left: '50%',
      margin: 0,
      opacity: 0,
      padding: 0,
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      top: '50%',
      pointerEvents: 'none'
    },
    "data-testid": testId
  }));
});